import { TRUSTED_COMPANY_NAMES } from '../../data/trustedCompanies';

type TrustedLogoMarqueeProps = {
  /** Scrolling strip (home hero). Static row for one-off layouts. */
  variant?: 'marquee' | 'static';
  /** Dark hero uses light text; light panels use navy text. */
  theme?: 'dark' | 'light';
};

/** Scrolling or static strip of trusted company names. */
export default function TrustedLogoMarquee({
  variant = 'marquee',
  theme = 'dark',
}: TrustedLogoMarqueeProps) {
  const themeClass = theme === 'light' ? 'trusted-marquee--light' : 'trusted-marquee--dark';

  if (variant === 'static') {
    return (
      <div
        className={`trusted-logos trusted-logos--static ${themeClass}`}
        aria-label="Trusted companies"
      >
        {TRUSTED_COMPANY_NAMES.map((name) => (
          <div className="trusted-logos__item" key={name}>
            <span className="trusted-marquee__label">{name}</span>
          </div>
        ))}
      </div>
    );
  }

  const track = [...TRUSTED_COMPANY_NAMES, ...TRUSTED_COMPANY_NAMES];

  return (
    <div className={`trusted-marquee ${themeClass}`} aria-label="Trusted companies">
      <div className="trusted-marquee__track">
        {track.map((name, index) => (
          <div
            className="trusted-marquee__item"
            key={`${name}-${index}`}
            aria-hidden={index >= TRUSTED_COMPANY_NAMES.length}
          >
            <span className="trusted-marquee__label">{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
